
uniform float u_size;
uniform float u_progress;
uniform vec2 u_resolution;
// varyings

varying vec2 vUv;
// attributes
attribute float a_size;

float remap(float value, float originMin, float originMax, float destinationMin, float destinationMax)
{
    return destinationMin + (value - originMin) * (destinationMax - destinationMin) / (originMax - originMin);
}

void main(){


    vec3 newPos = position;
    // Exploding
    float expodingProgress = remap(u_progress, 0.0, 0.5, 0.0, 1.0);
    expodingProgress = clamp(expodingProgress, 0.0, 1.0);
    expodingProgress = 1.0-pow(1.0-expodingProgress, 3.0);
    newPos *= expodingProgress;
    // Falling
    float fallingProgress = remap(u_progress, 0.1, 1.0, 0.0, 1.0);
    fallingProgress = clamp(fallingProgress, 0.0, 1.0);
    fallingProgress = 1.0 - pow(1.0 - fallingProgress, 3.0);
    newPos.y -= fallingProgress * 0.2;
    // finalPosition

    vec4 modelPosition = modelMatrix * vec4(newPos, 1.);



    vec4 viewPosition = viewMatrix*modelPosition;
    gl_Position = projectionMatrix * viewPosition;
    // final size
    // apply the perspective
    gl_PointSize = u_size * u_resolution.y * a_size ;
    gl_PointSize *= 1. / -viewPosition.z;

}


